import React, { useState } from 'react';
import { Typography, IconButton } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
 
const StationStatisticsPortfolioSummary = ({ stations, portfolioLevel }) => {
  const [expanded, setExpanded] = useState(false);
  const showCollapse = stations.length > 15;
 
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
 
  const getProcessedStationsList = () => {
    if (!stations.length) {
      return '<span style="color: #999;">No stations available</span>';
    }
 
    const stationsHtml = stations.map(station =>
      `<span class="station-badge">${station.description || station.name}</span>`
    );
 
    if (!showCollapse || expanded) {
      return stationsHtml.join('');
    }
 
    const visibleStations = stationsHtml.slice(0, 5).join('');
    const remainingCount = stationsHtml.length - 5;
    return visibleStations + ` <span class="station-badge">+${remainingCount} more...</span>`;
  };
 
  return (
    <div className="portfolio-summary" style={{ padding: '10px 15px' }}>
      <Typography className="portfolioFaultLevel" variant="subtitle1">
        <strong>📍 Portfolio Selection: {portfolioLevel.charAt(0).toUpperCase() + portfolioLevel.slice(1)}</strong>
      </Typography>
      <Typography className="portfolioFaultLevel" variant="subtitle1">
        <strong>
          📌 Total Stations: {stations.length}
        </strong>
      </Typography>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
        <Typography
          className="portfolioFaultLevel"
          variant="subtitle1"
          component="div"
          style={{ flex: 1 }}
          dangerouslySetInnerHTML={{ __html: `<strong>🌏 Stations:</strong> ${getProcessedStationsList()}` }}
        />
        {showCollapse && (
          <IconButton
            onClick={handleExpandClick}
            size="small"
            style={{
              marginTop: '4px',
              padding: '4px'
            }}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </div>
    </div>
  );
};
 
export default StationStatisticsPortfolioSummary;